// ControlSoundAssetFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import ControlModel    from 'ControlModel.js';
import AssetSoundView  from 'advanced-inputs/AssetSoundView.js';


//=============================================================================
//
// Creates a Sound control view. It will be rendered in the Asset Placeholder at the bottom of the editor window.
//
// Brad Trebilcock, February 21, 2016
//
//=============================================================================
class ControlSoundAssetFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.autoplay = '';
        attributes.loop = '';
        attributes.volume = 25;

        const view = new AssetSoundView( { model: new ControlModel( attributes ), el:constants.PAGE_ASSETS_ID, factoryKey: factoryKey, id: attributes.id} );

        return view;
    }

}

const controlSoundAssetFactory = new ControlSoundAssetFactory();

export default controlSoundAssetFactory;
